import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button, ModalBody, ModalFooter } from 'reactstrap';

import { setUserSetting, updateUserSettings } from '../../actions/Auth';

import { getCurrentUser, userIsAdmin, userIsManager } from '../../helpers/Auth';

import ErrorBoundary from '../ErrorBoundary';

const CollectionCreatedModal = ({ handleClose, collectionUuid }) => {
  const intl = useIntl();

  if (!(userIsAdmin() || userIsManager())) {
    return null;
  }

  return (
    <ErrorBoundary>
      <ModalBody>
        <h4>
          {intl.formatMessage({ defaultMessage: 'Nice work!' })}
        </h4>
        <p>
          {intl.formatMessage({ defaultMessage: 'Your Collection has been created, add some files!' })}
        </p>
      </ModalBody>
      <ModalFooter>
        <div className="buttons-group">
          <Button
            color="link"
            onClick={handleClose}
            className="mr-2"
          >
            {intl.formatMessage({ defaultMessage: 'Close' })}
          </Button>
          <Button
            color="primary"
            tag={Link}
            to={`/collections/${collectionUuid}`}
            onClick={handleClose}
          >
            {intl.formatMessage({ defaultMessage: 'Go to Collection' })}
          </Button>
        </div>
      </ModalFooter>
    </ErrorBoundary>
  );
};

const mapDispatchToProps = (dispatch) => ({
  handleUserSetting: (setting) => {
    const profile = getCurrentUser();
    if (profile) {
      dispatch(setUserSetting(setting));
      dispatch(updateUserSettings(profile.uuid, setting));
    }
  },
});

CollectionCreatedModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  collectionUuid: PropTypes.string.isRequired,
};

export default connect(null, mapDispatchToProps)(CollectionCreatedModal);
